import { MonoBehaviourMessageCenter } from "./MonoBehaviourMessageCenter";
import { SocketHandle, VerySendMode, VeryEngineNode } from "./SocketBusiness";
import { ByteBuffer } from "./ByteBuffer";
import { SocketManager } from "./SocketManager";
import { VeryNettyPara } from "./VeryNettyPara";
import { Dictionary } from "../utility/dictionary";
import { Game } from "../game";
import { Exhibits } from "../exhibits";
import $ from "jquery";
import { VeryList, VeryString, VeryNumber, VeryBool } from "../veryNetty/veryVariables";
import { GlobalControl } from "../globalControl";

export class VeryCharacter {
    private _modelPath: string;
    private _modelName: string;
    private _person: BABYLON.AbstractMesh | BABYLON.UniversalCamera;
    private _virtual: BABYLON.Mesh;
    private _recordPos: BABYLON.Vector4;
    private _dirMoveDic = { "up": false, "down": false, "left": false, "right": false,'rot':false };
    private _posInfoHeap: { time: number, dir: BABYLON.Vector4 }[] = [];
    private _currentTarget: { time: number, dir: BABYLON.Vector4 } | undefined;
    private _recordTarget: { time: number, dir: BABYLON.Vector4 } | undefined;
    private _lastTarget: { time: number, dir: BABYLON.Vector4 } | undefined;
    private _tmpTarget:BABYLON.Vector4;
    private _loadState = 0;
    private rTime = 0;
    private _moveState = false;
    private _moveState2 = false;
    private _moveCache = false;
    private mTime = 0;
    private _button: BABYLON.GUI.Button;

    private static _allCharacters: Dictionary<number, VeryCharacter> = new Dictionary<number, VeryCharacter>();
    private static _myCharacterIndex: number;
    public static _scence: BABYLON.Scene;
    private static _forceMove: number[] = [];
    private static _moveStart = false;
    private static _moveEnd = false;

    public static profile = new VeryString("profile", "");
    public static personalProfile = new VeryString("profile", "");
    public static profileArray: string[] = [];
    public static resumeProfile = new VeryList("personalProfile", new VeryString("", ""));
    private _message: BABYLON.GUI.TextBlock;
    private _mesh: BABYLON.TransformNode;
    public static _timer: any;
    private _msTimer: any;
    private _ballMesh: BABYLON.AbstractMesh;
    private static _moveType = 1;
    private pickinfo: BABYLON.PickingInfo = null
    public static isFollowed:boolean = false;
    public static isGuided:boolean = false;

    private IsNotMove(tag) {
        let result = !this._dirMoveDic["up"] && !this._dirMoveDic["down"] && !this._dirMoveDic["left"] && !this._dirMoveDic["right"]
        &&!this._dirMoveDic['rot'];
        if (tag) {
            if (result) {
                this.rTime = new Date().getTime();
                this.time3 = this.rTime;
                VeryCharacter._moveStart = true;
                VeryCharacter._moveEnd = false;
            }
        }
        else {
            if (result) {
                VeryCharacter._moveEnd = true;
            }
        }

    }
    private time3 = 0;
    private vec3sDiff = BABYLON.Vector4.Zero();
    private timesRevise = 0;


    public constructor(self: boolean, pos: BABYLON.Vector4|BABYLON.Vector2, characterIndex: number) {
        let that = this;
        if (VeryNettyPara.characterPath == undefined || VeryNettyPara.characterPath === "") {
            console.error("人物模型位置信息未配置！！");
            return;
        }
        let tmpSplit = VeryNettyPara.characterPath.split("/|\\");
        this._modelPath = tmpSplit[0];
        this._modelName = tmpSplit[1];
        if(pos instanceof BABYLON.Vector2){
            pos=new BABYLON.Vector4(pos.x,pos.y,VeryNettyPara.characterRot.x,VeryNettyPara.characterRot.y);
        }
        console.log(self)
        if (self) {
            this.CreatVirtual(pos);
            VeryCharacter._scence.onKeyboardObservable.add(kbInfo => {
                if (kbInfo.type === BABYLON.KeyboardEventTypes.KEYDOWN) {
                    if (kbInfo.event.keyCode === 87 || kbInfo.event.keyCode === 38) {
                        this.IsNotMove(true);
                        this._dirMoveDic["up"] = true;
                    }
                    else if (kbInfo.event.keyCode === 83 || kbInfo.event.keyCode === 40) {
                        that.IsNotMove(true);
                        this._dirMoveDic["down"] = true;
                    }
                    if (kbInfo.event.keyCode === 65 || kbInfo.event.keyCode === 37) {
                        this.IsNotMove(true);
                        this._dirMoveDic["left"] = true;
                    }
                    else if (kbInfo.event.keyCode === 68 || kbInfo.event.keyCode === 39) {
                        this.IsNotMove(true);
                        this._dirMoveDic["right"] = true;
                    }
                }
                if (kbInfo.type === BABYLON.KeyboardEventTypes.KEYUP) {
                    if (kbInfo.event.keyCode === 87 || kbInfo.event.keyCode === 38) {
                        that._dirMoveDic["up"] = false;
                        that.IsNotMove(false);
                    }
                    else if (kbInfo.event.keyCode === 83 || kbInfo.event.keyCode === 40) {
                        this._dirMoveDic["down"] = false;
                        this.IsNotMove(false);
                    }
                    if (kbInfo.event.keyCode === 65 || kbInfo.event.keyCode === 37) {
                        this._dirMoveDic["left"] = false;
                        this.IsNotMove(false);
                    }
                    else if (kbInfo.event.keyCode === 68 || kbInfo.event.keyCode === 39) {
                        this._dirMoveDic["right"] = false;
                        this.IsNotMove(false);
                    }

                }
            });
            VeryCharacter._scence.onPointerObservable.add((pointerInfo)=>{
                if(pointerInfo.type==BABYLON.PointerEventTypes.POINTERDOWN){
                    this.IsNotMove(true);
                    this._dirMoveDic['rot']=true;
                } else if(pointerInfo.type==BABYLON.PointerEventTypes.POINTERUP){
                    this._dirMoveDic['rot']=false;
                    this.IsNotMove(false);
                }
            })
            //方向按钮
            Exhibits.forwardBtn.onPointerDownObservable.add(() => {
                this.IsNotMove(true);
                this._dirMoveDic["up"] = true;
            });
            Exhibits.forwardBtn.onPointerUpObservable.add(() => {
                that._dirMoveDic["up"] = false;
                that.IsNotMove(false);
            });
            Exhibits.backBtn.onPointerDownObservable.add(() => {
                that.IsNotMove(true);
                this._dirMoveDic["down"] = true;
            });
            Exhibits.backBtn.onPointerUpObservable.add(() => {
                this._dirMoveDic["down"] = false;
                this.IsNotMove(false);
            });
            Exhibits.leftBtn.onPointerDownObservable.add(() => {
                this.IsNotMove(true);
                this._dirMoveDic["left"] = true;
            });
            Exhibits.leftBtn.onPointerUpObservable.add(() => {
                this._dirMoveDic["left"] = false;
                this.IsNotMove(false);
            });
            Exhibits.rightBtn.onPointerDownObservable.add(() => {
                this.IsNotMove(true);
                this._dirMoveDic["right"] = true;
            });
            Exhibits.rightBtn.onPointerUpObservable.add(() => {
                this._dirMoveDic["right"] = false;
                this.IsNotMove(false);
            });
            VeryCharacter._scence.onBeforeRenderObservable.add(function () {
                if (that._virtual != undefined && that._person != undefined) {
                    let t = new Date().getTime();
                    let tmp = (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).rotation;
                    let tmpV3 = new BABYLON.Vector3(0, 0, 0)
                    if (that._dirMoveDic["up"]) {
                        tmpV3 = tmpV3.add(new BABYLON.Vector3(Math.sin(tmp.y), 0, Math.cos(tmp.y)));
                    }
                    if (that._dirMoveDic["down"]) {
                        tmpV3 = tmpV3.add(new BABYLON.Vector3(-Math.sin(tmp.y), 0, -Math.cos(tmp.y)));
                    }
                    if (that._dirMoveDic["left"]) {
                        tmpV3 = tmpV3.add(new BABYLON.Vector3(-Math.cos(tmp.y), 0, Math.sin(tmp.y)));
                    }
                    if (that._dirMoveDic["right"]) {
                        tmpV3 = tmpV3.add(new BABYLON.Vector3(Math.cos(tmp.y), 0, -Math.sin(tmp.y)));
                    }
                    if (tmpV3.length() != 0) {
                        let tmpSpeed = (t - that.time3) / 20 * VeryNettyPara.moveSpeed;
                        tmpV3 = tmpV3.normalize().multiplyByFloats(tmpSpeed, 0, tmpSpeed);
                        tmpV3.y = -9.8;
                        that._virtual.moveWithCollisions(tmpV3);
                    }
                    that.time3 = t;
                }
            });
        }
        VeryCharacter._scence.onBeforeRenderObservable.add(function () {
            let nowTime = new Date().getTime();
            if (that._moveState || that._moveState2 && that._person != undefined) {
                if (that._posInfoHeap.length > 0 && that._currentTarget === undefined) {
                    that._moveCache = true;
                    that.nextTarget.apply(that);
                }
                let timeDiff2 = nowTime - that.mTime;
                if (that._currentTarget) {
                    if (that._lastTarget && that._lastTarget.time != 0) {
                        let vec3Diff = that._currentTarget.dir.multiplyByFloats(that._currentTarget.time, that._currentTarget.time, that._currentTarget.time,that._currentTarget.time)
                            .subtract(that._lastTarget.dir.multiplyByFloats(that._lastTarget.time, that._lastTarget.time, that._lastTarget.time,that._lastTarget.time));
                        let timeRevise = that._currentTarget.time - that._lastTarget.time;
                        that._lastTarget.time = 0;
                        that.timesRevise = timeRevise + that.timesRevise;
                        that.vec3sDiff = that.vec3sDiff.add(vec3Diff);
                        while (that.timesRevise <= 0) {
                            that.nextTarget.apply(that);
                            if (!that._currentTarget)
                                break;
                            that.vec3sDiff = that.vec3sDiff.add(that._currentTarget.dir.multiplyByFloats(that._currentTarget.time, that._currentTarget.time, that._currentTarget.time,that._currentTarget.time));
                            that.timesRevise = that.timesRevise + that._currentTarget.time;
                        }
                        if (that._currentTarget != null) {
                            that._currentTarget.dir = that.vec3sDiff.multiplyByFloats(1 / that.timesRevise, 1 / that.timesRevise, 1 / that.timesRevise,1 / that.timesRevise);
                            that._currentTarget.time = that.timesRevise;
                            that.vec3sDiff = BABYLON.Vector4.Zero();
                            that.timesRevise = 0;
                        }
                    }
                    if (that._currentTarget) {
                        let targetTime = that._currentTarget.time - timeDiff2;
                        while (targetTime <= 0 && that._currentTarget != null) {
                            let posDir=new BABYLON.Vector3(that._currentTarget.dir.x,0,that._currentTarget.dir.y);
                            let rotDir=new BABYLON.Vector3(that._currentTarget.dir.z,that._currentTarget.dir.w,0);
                            that._person.position = that._person.position.add(posDir.multiplyByFloats(that._currentTarget.time, 0, that._currentTarget.time));
                            that._person.rotation=that._person.rotation.add(rotDir.multiplyByFloats(that._currentTarget.time,that._currentTarget.time,0));
                            timeDiff2 = -targetTime;
                            that.nextTarget.apply(that);
                            if (that._currentTarget != null)
                                targetTime = that._currentTarget.time - timeDiff2;

                        }
                        if (that._currentTarget != null) {
                            let posDir=new BABYLON.Vector3(that._currentTarget.dir.x,0,that._currentTarget.dir.y);
                            let rotDir=new BABYLON.Vector3(that._currentTarget.dir.z,that._currentTarget.dir.w,0);
                            that._person.position = that._person.position.add(posDir.multiplyByFloats(timeDiff2, 0, timeDiff2));
                            that._person.rotation=that._person.rotation.add(rotDir.multiplyByFloats(timeDiff2,timeDiff2,0))
                            that._currentTarget.time = targetTime;
                        }
                    }
                }
                if (!that._currentTarget && that._moveCache && that._lastTarget != null) {
                    let posDir=new BABYLON.Vector3(that._lastTarget.dir.x,0,that._lastTarget.dir.y);
                    let rotDir=new BABYLON.Vector3(that._lastTarget.dir.z,that._lastTarget.dir.w,0);
                    that._person.position = that._person.position.add(posDir.multiplyByFloats(timeDiff2, 0, timeDiff2));
                    that._person.rotation=that._person.rotation.add(rotDir.multiplyByFloats(timeDiff2,timeDiff2,0))
                    that._lastTarget.time += timeDiff2;
                }
            }
            that.mTime = nowTime;
        })
        this.CreatCharacter(pos, VeryNettyPara.characterScal, self, characterIndex);
        if (self) {
            // VeryCharacter.AddCustom();
            VeryCharacter._scence.onPointerObservable.add((info) => {
                if (info.type === BABYLON.PointerEventTypes.POINTERDOUBLETAP && info.event.button === 0) {
                    if (info.pickInfo && info.pickInfo.hit) {
                        for (let i = 0; i < VeryCharacter._allCharacters.GetValues().length; i++) {
                            if (VeryCharacter._allCharacters.GetValueByIndex(i).Isyou(info.pickInfo.pickedMesh)) {
                                console.log('点击第' + VeryCharacter._allCharacters.GetKeyByIndex(i) + '号选手');
                                console.log(VeryNettyPara.haslogin)
                                //双击之后发送打招呼的消息
                                if (VeryNettyPara.haslogin) {
                                    window.document.getElementsByClassName("oldMessage")[0].innerHTML = "您已打了个招呼";
                                    VeryCharacter.GetUserName.SendSingle(VeryCharacter._allCharacters.GetKeyByIndex(i)); 

                                    VeryCharacter._scence.onBeforeRenderObservable.add(function () {
                                        if ((VeryCharacter._allCharacters.GetValueByIndex(i)) && VeryCharacter._allCharacters.GetValueByIndex(i)._mesh) {
                                            (VeryCharacter._allCharacters.GetValueByIndex(i)._mesh.parent as BABYLON.Mesh).rotation.y = (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).rotation.y;
                                            (VeryCharacter._allCharacters.GetValueByIndex(i)._mesh.parent as BABYLON.Mesh).rotation.x =0;
                                        }
                                    })
                                    break;
                                }
                            }
                        }
                    }
                }
                //发送消息
                if (info.type === BABYLON.PointerEventTypes.POINTERTAP && info.event.button === 0) {
                    $(".send").on("click", () => {
                        let content = window.document.getElementsByClassName("inputContent")[0] as HTMLInputElement;
                        let message = window.document.getElementsByClassName("oldMessage")[0];
                        if (content.value.length > 0 && VeryNettyPara.haslogin) {
                            message.innerHTML = VeryCharacter.profileArray[0] + ": " + content.value;
                            VeryCharacter.SendMessage.SendOthers(VeryCharacter._myCharacterIndex, content.value);
                            content.value = "";
                        } else if (!VeryNettyPara.haslogin) {
                            $(".system-alert").removeClass("hidden")
                            setTimeout(() => {
                                $(".system-alert").addClass("hidden")
                            }, 1500)
                        }
                    })
                }
            });
            //inputContent绑定enter
            $(".inputContent").keydown(function (e) {//当按下按键时
                if (e.keyCode == 13) {//.which属性判断按下的是哪个键，回车键的键位序号为13
                    let content = window.document.getElementsByClassName("inputContent")[0] as HTMLInputElement;
                    let message = window.document.getElementsByClassName("oldMessage")[0];
                    if (content.value.length > 0 && VeryNettyPara.haslogin) {
                        message.innerHTML = VeryCharacter.profileArray[0] + ": " + content.value;
                        VeryCharacter.SendMessage.SendOthers(VeryCharacter._myCharacterIndex, content.value);
                        content.value = "";
                    } else if (!VeryNettyPara.haslogin) {
                        $(".system-alert").removeClass("hidden")
                        setTimeout(() => {
                            $(".system-alert").addClass("hidden")
                        }, 1500)
                    }
                }
            });
            //实例化在自己登录后展馆中的角色
            let aa: boolean = false;
            VeryCharacter._scence.onBeforeRenderObservable.add(function () {
                if (VeryNettyPara.haslogin && !aa && VeryCharacter.profileArray[0]) {
                    aa = true;
                    VeryCharacter.updateIDAfter.SendOthers(VeryCharacter._myCharacterIndex, VeryCharacter.profileArray[0] + "," + VeryCharacter.profileArray[1]);
                }

            })

        }
        MonoBehaviourMessageCenter.Instance.AddUpdateEvent(this.sendPosInfo.bind(this));
    }

    public Isyou(virtual) {
        if (this._person === virtual) {
            return true;
        }
        else if (!virtual.parent) {
            return false;
        }
        else if (virtual.parent === this._person) {
            return true;
        }
        else {
            return this.Isyou(virtual.parent);
        }
    }
    public CreatVirtual(pos: BABYLON.Vector4) {
        this._virtual = BABYLON.MeshBuilder.CreateSphere("角色", { diameter: 40, diameterY: VeryNettyPara.characterHigh }, VeryCharacter._scence);
        this._virtual.visibility = 0;
        this._virtual.position = new BABYLON.Vector3(pos.x, VeryNettyPara.characterPos.y, pos.y);
        this._virtual.ellipsoid = new BABYLON.Vector3(8, 60, 8);
        this._virtual.ellipsoidOffset = new BABYLON.Vector3(0, 80 - VeryNettyPara.characterHigh, 0);
        this._virtual.checkCollisions = true;
        this._virtual.isVisible = false;
    }

    private Destory() {
        if (this._person)
            this._person.dispose();
    }

    private CreatCharacter(vec4: BABYLON.Vector4, scal: BABYLON.Vector3, self: boolean, characterIndex: number) {
        let that = this;
        let rot=new BABYLON.Vector3(vec4.z,vec4.w,0);
        let pos=new BABYLON.Vector3(vec4.x,VeryNettyPara.characterPos.y,vec4.y);
        if (self) {
            that._person = VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera;
            VeryCharacter._scence.activeCamera.position.x = pos.x;
            VeryCharacter._scence.activeCamera.position.z = pos.z;
            that._loadState = 2;
            if (VeryCharacter._moveType == 1) {
                that._person.parent = that._virtual;
                VeryCharacter._scence.activeCamera.position.x = 0;
                VeryCharacter._scence.activeCamera.position.z = 0;
                VeryCharacter._scence.activeCamera.position.y = -20;
            }
        }
        else {
            if (pos) {
                BABYLON.SceneLoader.ImportMesh("", this._modelPath, this._modelName, VeryCharacter._scence, function (newMeshes) {
                    if (newMeshes.length > 0) {
                        that._person = newMeshes[0];
                        newMeshes[0].rotation = rot;
                        newMeshes[0].scaling = scal;
                        newMeshes[0].position = pos;
                        console.log(newMeshes[0].position, newMeshes[0].name, that._person.position)
                        newMeshes[0].isPickable = true;
                        newMeshes[1].isPickable = true;
                        newMeshes[2].isPickable = false;
                        newMeshes[2].isVisible = false;
                        newMeshes[1].visibility = 0.8;
                        let aa = Game.messagePanel(newMeshes[2].parent, "plane", "游客", 180, 180, 0, VeryCharacter._scence)
                        that._button = aa[0];
                        if (Game.style === "dangjianfeng" || Game.style === "xindangjianfeng" || Game.style === "xindangjianfeng2" || Game.style === "xindangjianfeng3") {
                            that._button.background = "#F74B4B65"
                        }
                        that._message = aa[1];
                        that._mesh = aa[2];
                        that._ballMesh = newMeshes[1];
                        //button
                        that._button.onPointerClickObservable.add(() => {
                            if (VeryNettyPara.haslogin && VeryCharacter.profileArray[0]) {
                                //人见人交互界面
                                VeryCharacter.checkIfLogin.SendSingle(characterIndex);
                            }
                        })
                    }
                    that._loadState = 1;
                })
            }
        }
    }

    public static nextTurn() {
        VeryNettyPara.GameTurnStart = true;
        if (VeryCharacter._moveStart) {
            VeryCharacter._moveStart = false;
        }
        if (VeryCharacter._moveEnd) {
            let buf = ByteBuffer.Allocate(2);
            buf.WriteByte(SocketHandle.FrameMove);
            buf.WriteBoolean(false)
            SocketManager.Instance.PoolSendMsg(buf);
            VeryCharacter._moveEnd = false;
        }
        MonoBehaviourMessageCenter.Instance.NextTurn();
        SocketManager.Instance.SendMsgBase();
    }

    private nextTarget() {
        if (this._posInfoHeap.length > 0) {
            if (this._loadState != 0) {
                if (this._loadState == 2) {
                    if (this._currentTarget != null) {
                        this._lastTarget = this._recordTarget;
                        this._lastTarget.time = 0;
                    }
                    this._currentTarget = this._posInfoHeap.shift();
                    this._recordTarget = { time: this._currentTarget.time, dir: this._currentTarget.dir };
                }
                else {
                    if(this._tmpTarget){
                        this._person.position = new BABYLON.Vector3(this._tmpTarget.x,VeryNettyPara.characterPos.y,this._tmpTarget.y);
                        this._person.rotation=new BABYLON.Vector3(this._tmpTarget.z,this._tmpTarget.w,0)
                    }
                    let count = this._posInfoHeap.length;
                    //模型加载完直接定位到最新位置
                    for (let i = 0; i < count - 1; i++) {
                        this._currentTarget = this._posInfoHeap.shift();
                        this._recordTarget = { time: this._currentTarget.time, dir: this._currentTarget.dir };
                        let posDir=new BABYLON.Vector3(this._currentTarget.dir.x,0,this._currentTarget.dir.y);
                        let rotDir=new BABYLON.Vector3(this._currentTarget.dir.z,this._currentTarget.dir.w,0);
                        this._person.position = this._person.position.add(posDir.multiplyByFloats(this._currentTarget.time, 0, this._currentTarget.time));
                        this._person.rotation=this._person.rotation.add(rotDir.multiplyByFloats(this._currentTarget.time,this._currentTarget.time,0))
                    }
                    if (count > 1) {
                        if (this._currentTarget != null) {
                            this._lastTarget = this._recordTarget;
                            this._lastTarget.time = 0;
                        }
                        this._currentTarget = this._posInfoHeap.shift();
                        this._recordTarget = { time: this._currentTarget.time, dir: this._currentTarget.dir };
                    }
                    this._loadState = 2;
                }
            }
        }
        else {
            if (this._moveState2) {
                this._moveState2 = false;
                if (this.timesRevise != 0) {
                    this._person.position = this._person.position.add(new BABYLON.Vector3(this.vec3sDiff.x,0,this.vec3sDiff.y));
                    this._person.rotation=this._person.rotation.add(new BABYLON.Vector3(this.vec3sDiff.z,this.vec3sDiff.w,0))
                    this.vec3sDiff = BABYLON.Vector4.Zero();
                    this.timesRevise = 0
                }
                this._lastTarget = undefined;
            }
            this._currentTarget = undefined;
        }
    }

    private GetPlayIndex(play: VeryCharacter) {
        let keys = VeryCharacter._allCharacters.GetKeys();
        for (let i = 0; i < keys.length; i++) {
            if (VeryCharacter._allCharacters.GetValue(keys[i]) == play) {
                return keys[i];
            }
        }
        return -1;
    }
    public static SetPosition(x: number, z: number, obj?) {
        let buf = ByteBuffer.Allocate(33);
        let index = VeryCharacter._myCharacterIndex;
        let tmp: VeryCharacter = VeryCharacter._allCharacters.GetValue(index);
        tmp._recordPos.x = x;
        tmp._recordPos.z = z;
        tmp._virtual.position.x = x;
        tmp._virtual.position.z = z;
        if (VeryCharacter._moveType == 0) {
            tmp._person.position.x = x;
            tmp._person.position.z = z;
        }
        buf.WriteByte(SocketHandle.GameTurn);
        buf.WriteInt(VerySendMode.Other);
        buf.WriteByte(VeryEngineNode.Pos);
        
        if (VeryCharacter._moveType == 1) {
            tmp._person.parent = null;
            tmp._person.position = new BABYLON.Vector3(tmp._virtual.position.x, tmp._virtual.position.y, tmp._virtual.position.z);
        }
        if (obj) {
            (tmp._person as BABYLON.UniversalCamera).setTarget(obj);
        }
        if (VeryCharacter._moveType == 1) {
            tmp._person.parent = tmp._virtual;
            tmp._person.position = new BABYLON.Vector3(0, -20, 0);
        }
        tmp._recordPos.z=tmp._person.rotation.x;
        tmp._recordPos.w=tmp._person.rotation.y;
        if (index < 0) {
            console.log("当前玩家尚未计入在线统计中,请联系程序猿！");
        }
        else {
            buf.WriteInt(index);
            buf.WriteFloat(tmp._recordPos.x);
            buf.WriteFloat(tmp._recordPos.y);
            buf.WriteFloat(tmp._recordPos.z);
            buf.WriteFloat(tmp._recordPos.w);
            SocketManager.Instance.PoolSendMsg(buf);
        }
    }
    private sendPosInfo() {
        if (this._virtual) {
            if (!this._recordPos) {
                let buf = ByteBuffer.Allocate(29);
                this._recordPos = new BABYLON.Vector4(this._virtual.position.x,this._virtual.position.z,this._person.rotation.x,this._person.rotation.y);
                buf.WriteByte(SocketHandle.GameTurn);
                buf.WriteInt(VerySendMode.Other);
                buf.WriteByte(VeryEngineNode.Pos);
                //todo 角色识别
                let index = this.GetPlayIndex(this);
                if (index < 0) {
                    console.log("当前玩家尚未计入在线统计中,请联系程序猿！");
                }
                else {
                    buf.WriteInt(index);
                    buf.WriteFloat(this._recordPos.x);
                    buf.WriteFloat(this._recordPos.y);
                    buf.WriteFloat(this._recordPos.z);
                    buf.WriteFloat(this._recordPos.w);
                    SocketManager.Instance.PoolSendMsg(buf);
                }

            } else if (!this._recordPos.equalsWithEpsilon(new BABYLON.Vector4(this._virtual.position.x,this._virtual.position.z,this._person.rotation.x,this._person.rotation.y))) {
                let nowTime = new Date().getTime();
                let timeDiff = nowTime - this.rTime;
                if (timeDiff > 20) {
                    this.rTime = nowTime;
                    let dirDiff = this._virtual.position.subtract(new BABYLON.Vector3(this._recordPos.x,0,this._recordPos.y)).multiplyByFloats(1 / timeDiff, 0, 1 / timeDiff);
                    let angDiff=this._person.rotation.subtract(new BABYLON.Vector3(this._recordPos.z,this._recordPos.w,0)).multiplyByFloats(1 / timeDiff,1 / timeDiff,0);
                    this._recordPos = new BABYLON.Vector4(this._virtual.position.x,this._virtual.position.z,this._person.rotation.x,this._person.rotation.y)

                    let buf = ByteBuffer.Allocate(33);
                    buf.WriteByte(SocketHandle.GameTurn);
                    if (VeryCharacter._moveType == 0)
                        buf.WriteInt(VerySendMode.All);
                    else if (VeryCharacter._moveType === 1)
                        buf.WriteInt(VerySendMode.Other);
                    buf.WriteByte(VeryEngineNode.Move);
                    //todo 角色识别
                    let index = this.GetPlayIndex(this);
                    if (index < 0) {
                        console.log("当前玩家尚未计入在线统计中,请联系程序猿！");
                    }
                    else {
                        buf.WriteInt(index);
                        buf.WriteFloat(dirDiff.x);
                        buf.WriteFloat(dirDiff.z);
                        buf.WriteFloat(angDiff.x);
                        buf.WriteFloat(angDiff.y);
                        buf.WriteInt(timeDiff);
                        SocketManager.Instance.PoolSendMsg(buf);
                    }
                }
            }

            if (VeryCharacter._forceMove.length != 0) {
                this._recordPos = new BABYLON.Vector4(this._virtual.position.x,this._virtual.position.z,this._person.rotation.x,this._person.rotation.y)
                for (let i = 0; i < VeryCharacter._forceMove.length; i++) {
                    let buf = ByteBuffer.Allocate(29);
                    buf.WriteByte(SocketHandle.GameTurn);
                    buf.WriteInt(VeryCharacter._forceMove[i]);
                    buf.WriteByte(VeryEngineNode.Pos);
                    //todo 角色识别
                    let index = this.GetPlayIndex(this);
                    if (index < 0) {
                        console.log("当前玩家尚未计入在线统计中,请联系程序猿！");
                    }
                    else {
                        buf.WriteInt(index);
                        buf.WriteFloat(this._recordPos.x);
                        buf.WriteFloat(this._recordPos.y);
                        buf.WriteFloat(this._recordPos.z);
                        buf.WriteFloat(this._recordPos.w);
                        SocketManager.Instance.PoolSendMsg(buf);
                    }
                }
                VeryCharacter._forceMove = [];
            }
        }
    }

    public static AddBusiness(business: any) {
        let node = business.Node;
        business.Send = function (...param) {
            let buf = ByteBuffer.Allocate(300);
            buf.WriteByte(SocketHandle.GameTurn);
            buf.WriteInt(VerySendMode.All);
            buf.WriteByte(node);
            business.WriteValue(buf, ...param);
            SocketManager.Instance.PoolSendMsg(buf);
        }
        business.SendOthers = function (...param) {
            let buf = ByteBuffer.Allocate(300);
            buf.WriteByte(SocketHandle.GameTurn);
            buf.WriteInt(VerySendMode.Other);
            buf.WriteByte(node);
            business.WriteValue(buf, ...param);
            SocketManager.Instance.PoolSendMsg(buf);
        }
        business.SendSingle = function (index, ...param) {
            let buf = ByteBuffer.Allocate(300);
            buf.WriteByte(SocketHandle.GameTurn);
            buf.WriteInt(index);
            buf.WriteByte(node);
            business.WriteValue(buf, ...param);
            SocketManager.Instance.PoolSendMsg(buf);
        }
        VeryCharacter.customAccept[node] = function (buf) {
            business.Accept(buf);
        }
    }
    private static customAccept: { [index: number]: (buf: ByteBuffer) => void } = {};
    public static Aceppt(buf: ByteBuffer) {
        let mode = buf.ReadInt();
        let type = buf.ReadByte();
        if (type == VeryEngineNode.Pos) {
            let index = buf.ReadInt();
            let x = buf.ReadFloat();
            let y = buf.ReadFloat();
            let z = buf.ReadFloat();
            let w=buf.ReadFloat();

            if (!VeryCharacter._allCharacters.ContainsKey(index)) {
                VeryCharacter._allCharacters.Add(index, new VeryCharacter(false, new BABYLON.Vector4(x,y, z,w), index));
            }
            else {
                if(VeryCharacter._allCharacters.GetValue(index)._loadState == 2){
                    VeryCharacter._allCharacters.GetValue(index)._person.position = new BABYLON.Vector3(x, VeryNettyPara.characterPos.y, y);
                    VeryCharacter._allCharacters.GetValue(index)._person.rotation = new BABYLON.Vector3(z, w, 0);
                } else {
                    VeryCharacter._allCharacters.GetValue(index)._posInfoHeap = [];
                    VeryCharacter._allCharacters.GetValue(index)._tmpTarget = new BABYLON.Vector4(x,y,z,w);
                }
               
            }
        }
        else if (type == VeryEngineNode.Move) {
            let index = buf.ReadInt();
            let x = buf.ReadFloat();
            let y = buf.ReadFloat();
            let z = buf.ReadFloat();
            let w = buf.ReadFloat();
            let rtime = buf.ReadInt();
            if (VeryCharacter._allCharacters.ContainsKey(index)) {
                let tmp = { time: rtime, dir: new BABYLON.Vector4(x, y, z,w) };
                VeryCharacter._allCharacters.GetValue(index)._posInfoHeap.push(tmp);
                VeryCharacter._allCharacters.GetValue(index)._moveState = true;
            }
        }
        else if (type === VeryEngineNode.MoveSate) {
            let index = buf.ReadInt();
            let result = buf.ReadBoolean();
            if (VeryCharacter._allCharacters.ContainsKey(index)) {
                if (result)
                    VeryCharacter._allCharacters.GetValue(index)._moveState = true;
                else {
                    VeryCharacter._allCharacters.GetValue(index)._moveState = false;
                    VeryCharacter._allCharacters.GetValue(index)._moveCache = false;
                    VeryCharacter._allCharacters.GetValue(index)._moveState2 = true;
                }
            }
        }
        else if (type === VeryEngineNode.Character) {
            let index = buf.ReadInt();
            let self = (mode != 0)
            let x = buf.ReadFloat();
            let y = buf.ReadFloat();
            let z = buf.ReadFloat();

            //如果自身登录，需要将实例化所有已登录的角色
            if (self) {

            }
            //如果非自身登录，需要将自己的位置信息发给服务器
            else {
                VeryCharacter._forceMove.push(index);
                //实例化在自己登录前展馆中的角色
                //在其他角色页面中执行
                VeryCharacter.updateIDBefore.SendSingle(index);
            }
            let newCharacter = new VeryCharacter(self, new BABYLON.Vector2(x, z), index);
            if (self) {
                VeryCharacter._myCharacterIndex = index;
            }
            VeryCharacter._allCharacters.Add(index, newCharacter);
        }
        else if (type === VeryEngineNode.Exit) {
            let index = buf.ReadInt();
            if (VeryCharacter._allCharacters.ContainsKey(index)) {
                if(VeryCharacter.isFollowed){
                    $(".quitGuide-btn").addClass("hidden")
                    console.log("guide leave: "+index)
                    VeryCharacter.isGuided = false
                    VeryCharacter.isFollowed = false;
                    //恢复相机的父子关系和位置
                    let pos = (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).position
                    let char = VeryCharacter._scence.getMeshByName("角色")
                    char.setAbsolutePosition(pos);
                    VeryCharacter._scence.activeCamera.parent = null;
                    (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).position = new BABYLON.Vector3(0, -20, 0);
                    VeryCharacter._scence.activeCamera.parent = char;
                } else if(VeryCharacter.isGuided){
                    $(".quitGuide-btn").addClass("hidden")
                    console.log("follower leave: "+index)
                    VeryCharacter.isGuided = false;
                    VeryCharacter.isFollowed = false;
                    recStop()
                }
                VeryCharacter._allCharacters.GetValue(index).Destory();
                VeryCharacter._allCharacters.Remove(index);
            }
        }
        else if (VeryCharacter.customAccept[type]) {
            VeryCharacter.customAccept[type](buf);
        }
    }
    
    public static SendCreatCharacterRes(pos: BABYLON.Vector3) {
        let buf = ByteBuffer.Allocate(200);
        buf.WriteByte(SocketHandle.JoinGame);
        buf.WriteInt(-1);
        buf.WriteString(VeryNettyPara.ProjectID);
        buf.WriteBoolean(false);
        buf.WriteFloat(pos.x);
        buf.WriteFloat(pos.y);
        buf.WriteFloat(pos.z);
        SocketManager.Instance.SendMsg(buf);
    }

    public static AddCustom() {
        VeryCharacter.AddBusiness(VeryCharacter.GetUserId);
        VeryCharacter.AddBusiness(VeryCharacter.GetUserName);
        VeryCharacter.AddBusiness(VeryCharacter.SetSamePosition)
        VeryCharacter.AddBusiness(VeryCharacter.sendExhibitsEvent)
        VeryCharacter.AddBusiness(VeryCharacter.sendScreenEvent)
        VeryCharacter.AddBusiness(VeryCharacter.sendQuestionEvent)
        VeryCharacter.AddBusiness(VeryCharacter.Keydown);
        VeryCharacter.AddBusiness(VeryCharacter.SendExchangeNotice);
        VeryCharacter.AddBusiness(VeryCharacter.SendMessage);
        VeryCharacter.AddBusiness(VeryCharacter.updateIDBefore);
        VeryCharacter.AddBusiness(VeryCharacter.updateIDAfter);
        VeryCharacter.AddBusiness(VeryCharacter.SendExchangeBack);
        VeryCharacter.AddBusiness(VeryCharacter.refuseExchange);
        VeryCharacter.AddBusiness(VeryCharacter.checkIfLogin)
        VeryCharacter.AddBusiness(VeryCharacter.interaction)
        VeryCharacter.AddBusiness(VeryCharacter.SendGuideNotice)
        VeryCharacter.AddBusiness(VeryCharacter.SendGuideBack)
        VeryCharacter.AddBusiness(VeryCharacter.refuseGuide)
        VeryCharacter.AddBusiness(VeryCharacter.quitGuide)
        VeryCharacter.AddBusiness(VeryCharacter.quitFollow)
    }
    public static GetUserId: any = {
        Node: 4,
        WriteValue: (buf: ByteBuffer, index: number) => {
            buf.WriteString(VeryNettyPara.UserID);
            buf.WriteInt(index);
        },
        Accept: (buf) => {
            let userId = buf.ReadString();
            console.log(userId + "向你打招呼", buf.ReadInt());
            //读取对应id下个人信息
            SocketManager.Instance.GetValuesByID([VeryCharacter.profile], true, userId, 130, (() => {
                console.log(VeryCharacter.profile.value)
            }))
        }
    }

    public static Keydown: any = {
        Node: 5,
        WriteValue: (buf: ByteBuffer, index: number, dir: string) => {
            buf.WriteInt(index);
            buf.WriteString(dir);
        },
        Accept: (buf) => {
            let index = buf.ReadInt();
            let dir = buf.ReadString();
            console.log(index + "号选手：" + dir);
        }
    }

    public static GetUserName: any = {
        Node: 6,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryCharacter.profileArray[0]);
        },
        Accept: (buf) => {
            let userName = buf.ReadString();
            let message = window.document.getElementsByClassName("oldMessage")[0];
            if (VeryNettyPara.haslogin) {
                message.innerHTML = userName + "向你打招呼";
            }
        }
    }
    public static SetSamePosition: any = {
        Node: 23,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteInt(VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let number = buf.ReadInt();
            let index = parseInt(number)
            //跟随模式，设置相机，设置导游物体不显示
            VeryCharacter.isFollowed = true;
            VeryCharacter.isGuided = false;
            let scalY = (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).scaling.y;
            (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).position = new BABYLON.Vector3(0, -20/scalY, 0);
            (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).rotation = new BABYLON.Vector3(0, 0, 0);
            VeryCharacter._scence.activeCamera.parent = (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh);
            (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).setEnabled(false)
            //显示退出导游按钮
            $(".quitGuide-btn").removeClass("hidden")
            $(".quitGuide-btn").on("click", () => {
                $(".quitGuide-btn").addClass("hidden")
                recStop()
                VeryCharacter.isGuided = false
                VeryCharacter.isFollowed = false;
                (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).setEnabled(true);
                VeryCharacter.quitFollow.SendSingle(VeryCharacter._allCharacters.GetValue(index));
                //恢复相机的父子关系和位置
                let pos = (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).position
                let char = VeryCharacter._scence.getMeshByName("角色")
                char.setAbsolutePosition(pos);
                VeryCharacter._scence.activeCamera.parent = null;
                (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).position = new BABYLON.Vector3(0, -20, 0);
                VeryCharacter._scence.activeCamera.parent = char;
            })
        }
    }

    public static sendExhibitsEvent: any = {
        Node: 24,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(GlobalControl.exhibits.meshName);
        },
        Accept: (buf) => {
            let string = buf.ReadString();
            GlobalControl.exhibits.showExhibits(string);
            GlobalControl.exhibits.meshName = null

        }
    }
    public static sendScreenEvent: any = {
        Node: 25,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(GlobalControl.screenVideo.screenName);
        },
        Accept: (buf) => {
            let string = buf.ReadString();
            console.log(string)
            GlobalControl.screenVideo.showScreen(string, VeryCharacter._scence);
            GlobalControl.screenVideo.screenName = null

        }
    }

    public static sendQuestionEvent: any = {
        Node: 31,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(GlobalControl.question.lockName);
        },
        Accept: (buf) => {
            let string = buf.ReadString();
            console.log(string)
            GlobalControl.question.startExam(string)
            GlobalControl.question.lockName = null

        }
    }

    public static SendGuideNotice: any = {
        Node: 26,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let id = string[0];
            let userName = string[1];
            let guide = window.document.getElementsByClassName("guideNotice")[0] as HTMLElement;
            let guideName = window.document.getElementsByClassName("guideNotice-name")[0] as HTMLElement;
            if (VeryNettyPara.haslogin) {
                guide.style.display = "block";
                guideName.innerHTML = userName;
                //同意之后的操作
                $(".guideNotice-agree").on("click", () => {
                    guide.style.display = "none";
                    window.document.getElementsByClassName("oldMessage")[0].innerHTML = userName + "已跟随导游"
                    VeryCharacter.SendGuideBack.SendSingle(string[2]);
                })
                //拒绝之后的操作
                $(".guideNotice-refuse").on("click", () => {
                    guide.style.display = "none";
                    window.document.getElementsByClassName("oldMessage")[0].innerHTML = "您已拒绝" + userName + "为您导游";
                    VeryCharacter.refuseGuide.SendSingle(string[2]);
                });
            }
        }
    }

    public static SendGuideBack: any = {
        Node: 27,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let id = string[0];
            let userName = string[1];
            let index = parseInt(string[2])
            if (VeryNettyPara.haslogin) {
                //同意之后的操作
                //同步位置
                VeryCharacter.SetSamePosition.SendSingle(index);
                //设置参数,被跟随人物不显示
                VeryCharacter.isGuided = true
                VeryCharacter.isFollowed = false;
                (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).setEnabled(false);
                recStart()
                //显示退出导游按钮
                $(".quitGuide-btn").removeClass("hidden")
                $(".quitGuide-btn").on("click", () => {
                    $(".quitGuide-btn").addClass("hidden")
                    VeryCharacter.isGuided = false;
                    VeryCharacter.isFollowed = false;
                    (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).setEnabled(true);
                    VeryCharacter.quitGuide.SendSingle(index);
                })

                VeryCharacter._scence.onBeforeRenderObservable.add(function () {
                    if(VeryCharacter.isGuided){
                        //展画点击
                        if (GlobalControl.exhibits.meshName) {
                            VeryCharacter.sendExhibitsEvent.SendSingle(index);
                            GlobalControl.exhibits.meshName = null
                        }
                        //液晶屏点击
                        if (GlobalControl.screenVideo.screenName) {
                            VeryCharacter.sendScreenEvent.SendSingle(index);
                            GlobalControl.screenVideo.screenName = null
                        }
                        //门锁点击
                        if (GlobalControl.question.lockName) {
                            VeryCharacter.sendQuestionEvent.SendSingle(index);
                            GlobalControl.question.lockName = null
                        }
                    }
                })
            }
        }
    }

    public static refuseGuide: any = {
        Node: 28,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let id = string[0];
            let userName = string[1];
            if (VeryNettyPara.haslogin) {
                window.document.getElementsByClassName("oldMessage")[0].innerHTML = userName + "拒绝了您的导游请求";
            }
        }
    }

    public static quitGuide: any = {
        Node: 29,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteInt(VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let index = buf.ReadInt();
            $(".quitGuide-btn").addClass("hidden")
            VeryCharacter.isGuided = false
            VeryCharacter.isFollowed = false;
            (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).setEnabled(true);
            recStop()
            //恢复相机的父子关系和位置
            let pos = (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).position
            let char = VeryCharacter._scence.getMeshByName("角色")
            char.setAbsolutePosition(pos);
            VeryCharacter._scence.activeCamera.parent = null;
            (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).position = new BABYLON.Vector3(0, -20, 0);
            VeryCharacter._scence.activeCamera.parent = char;
        }
    }

    public static quitFollow: any = {
        Node: 30,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteInt(VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let index = buf.ReadInt();
            $(".quitGuide-btn").addClass("hidden")
            VeryCharacter.isGuided = false;
            VeryCharacter.isFollowed = false;
            (VeryCharacter._allCharacters.GetValue(index)._mesh.parent as BABYLON.Mesh).setEnabled(true);
        }
    }

    public static SendExchangeNotice: any = {
        Node: 7,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let id = string[0];
            let userName = string[1];
            let exchange = window.document.getElementsByClassName("exchange")[0] as HTMLElement;
            let exchangeName = window.document.getElementsByClassName("exchange-name")[0] as HTMLElement;
            if (VeryNettyPara.haslogin) {
                exchange.style.display = "block";
                exchangeName.innerHTML = userName;
                //同意之后的操作
                $(".exchange-agree").on("click", () => {
                    SocketManager.Instance.GetValuesByID([VeryCharacter.profile], true, id, 130, (() => {
                        console.log(VeryCharacter.profile.value);
                        let index = VeryCharacter.resumeProfile.indexOf(VeryCharacter.profile)
                        if (index === -1) {
                            //添加数据到存储数组中
                            VeryCharacter.resumeProfile.add(VeryCharacter.profile);
                            console.log(VeryCharacter.resumeProfile.value)
                            SocketManager.Instance.OperateOnlyPersonList(VeryCharacter.resumeProfile, VeryCharacter.profile, true, "add");
                            //更新当时通讯录中页面
                            let resume = VeryCharacter.profile.value.split(",")
                            if (resume[1] && resume[1] === "f") {
                                $("#cardcase-box-main").append(`
                                    <li class="business-card">
                                    <span class="iconfont icon--nvgaoliang"></span>
                                    <span class="card-name">${resume[0]}</span>
                                    <span class="card-phoneNo">${resume[2]}</span>
                                    </li>
                                `)
                            } else {
                                $("#cardcase-box-main").append(`
                                    <li class="business-card">
                                    <span class="iconfont icon--nangaoliang"></span>
                                    <span class="card-name">${resume[0]}</span>
                                    <span class="card-phoneNo">${resume[2]}</span>
                                    </li>
                                `)
                            }
                            window.document.getElementsByClassName("oldMessage")[0].innerHTML = resume[0] + "的名片已保存至通讯录"
                        } else {
                            window.document.getElementsByClassName("oldMessage")[0].innerHTML = userName + "的名片已存在";
                        }
                    }))
                    VeryCharacter.SendExchangeBack.SendSingle(string[2]);
                })
                //拒绝之后的操作
                $(".exchange-refuse").on("click", () => {
                    window.document.getElementsByClassName("oldMessage")[0].innerHTML = "您已拒绝和" + userName + "交换名片";
                    VeryCharacter.refuseExchange.SendSingle(string[2]);
                });
            }
        }
    }

    public static SendExchangeBack: any = {
        Node: 10,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let id = string[0];
            let userName = string[1];
            if (VeryNettyPara.haslogin) {
                //同意之后的操作
                SocketManager.Instance.GetValuesByID([VeryCharacter.profile], true, id, 131, (() => {
                    console.log(VeryCharacter.profile.value);
                    let index = VeryCharacter.resumeProfile.indexOf(VeryCharacter.profile)
                    if (index === -1) {
                        //添加数据到存储数组中
                        VeryCharacter.resumeProfile.add(VeryCharacter.profile);
                        console.log(VeryCharacter.resumeProfile.value)
                        SocketManager.Instance.OperateOnlyPersonList(VeryCharacter.resumeProfile, VeryCharacter.profile, true, "add");
                        //更新当时通讯录中页面
                        let resume = VeryCharacter.profile.value.split(",")
                        if (resume[1] && resume[1] === "f") {
                            $("#cardcase-box-main").append(`
                                    <li class="business-card">
                                    <span class="iconfont icon--nvgaoliang"></span>
                                    <span class="card-name">${resume[0]}</span>
                                    <span class="card-phoneNo">${resume[2]}</span>
                                    </li>
                                `)
                        } else {
                            $("#cardcase-box-main").append(`
                                    <li class="business-card">
                                    <span class="iconfont icon--nangaoliang"></span>
                                    <span class="card-name">${resume[0]}</span>
                                    <span class="card-phoneNo">${resume[2]}</span>
                                    </li>
                                `)
                        }
                        window.document.getElementsByClassName("oldMessage")[0].innerHTML = resume[0] + "的名片已保存至通讯录"
                    } else {
                        window.document.getElementsByClassName("oldMessage")[0].innerHTML = userName + "的名片已存在"
                    }

                }))
            }
        }
    }

    public static checkIfLogin: any = {
        Node: 13,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteInt(VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let index = buf.ReadInt()
            if (VeryNettyPara.haslogin) {
                VeryCharacter.interaction.SendSingle(index);
            }
        }
    }

    public static interaction: any = {
        Node: 14,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let index = string[2];
            let intIndex = parseInt(index)
            let userName = string[1];
            if (VeryNettyPara.haslogin) {
                window.document.getElementsByClassName("PTP-name")[0].innerHTML = userName
                $(".PTP-box").show(200)
                console.log(index, userName, $(".PTP-name").val())
                let _pressList = [".sayHiBtn", ".resumeBtn",".guideBtn"]
                let _pressed = null
                _pressList.forEach((className) => {
                    $(className).on("click", () => {
                        _pressList.forEach((item) => {
                            $(item).css({ background: "#ededed" })
                        })
                        $(className).css({ background: "#ADDBFF" })
                        _pressed = className
                    })
                })

                $(".PTP-cancel").on("click", () => {
                    $(".PTP-box").delay(200).hide(200)
                })

                $(".PTP-agree").on("click", () => {
                    if (_pressed === ".sayHiBtn") {
                        window.document.getElementsByClassName("oldMessage")[0].innerHTML = "您已打了个招呼";
                        VeryCharacter.GetUserName.SendSingle(index);
                        VeryCharacter._scence.onBeforeRenderObservable.add(function () {
                            if ((VeryCharacter._allCharacters.GetValue(intIndex)) && VeryCharacter._allCharacters.GetValue(intIndex)._mesh) {
                                (VeryCharacter._allCharacters.GetValue(intIndex)._mesh.parent as BABYLON.Mesh).rotation.y = (VeryCharacter._scence.activeCamera as BABYLON.UniversalCamera).rotation.y;
                                (VeryCharacter._allCharacters.GetValue(intIndex)._mesh.parent as BABYLON.Mesh).rotation.x = 0
                            }
                        })
                    } else if (_pressed === ".resumeBtn") {
                        window.document.getElementsByClassName("oldMessage")[0].innerHTML = "你已发送交换名片请求";
                        VeryCharacter.SendExchangeNotice.SendSingle(index);
                    } else if(_pressed === ".guideBtn"){
                        window.document.getElementsByClassName("oldMessage")[0].innerHTML = "你已发送导游请求";
                        VeryCharacter.SendGuideNotice.SendSingle(index);
                        
                    }
                    $(".PTP-box").delay(200).hide(200)
                })
            }
        }
    }

    public static refuseExchange: any = {
        Node: 11,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteString(VeryNettyPara.UserID + "," + VeryCharacter.profileArray[0] + "," + VeryCharacter._myCharacterIndex);
        },
        Accept: (buf) => {
            let string = buf.ReadString().split(",");
            let id = string[0];
            let userName = string[1];
            if (VeryNettyPara.haslogin) {
                window.document.getElementsByClassName("oldMessage")[0].innerHTML = userName + "拒绝了您的名片交换请求";
            }
        }
    }

    public static SendMessage: any = {
        Node: 8,
        WriteValue: (buf: ByteBuffer, index: number, message: string) => {
            buf.WriteInt(index);
            buf.WriteString(message);
        },
        Accept: (buf) => {
            let index = buf.ReadInt();
            let message = buf.ReadString();
            if (VeryCharacter._allCharacters.GetValue(index)._msTimer) {
                clearTimeout(VeryCharacter._allCharacters.GetValue(index)._msTimer);
            }
            VeryCharacter._allCharacters.GetValue(index)._message.text = "  " + message + "  ";
            VeryCharacter._allCharacters.GetValue(index)._msTimer = setTimeout(() => {
                VeryCharacter._allCharacters.GetValue(index)._message.text = "";
            }, 5000);
            let messageUI = window.document.getElementsByClassName("oldMessage")[0];
            messageUI.innerHTML = VeryCharacter._allCharacters.GetValue(index)._button.textBlock.text + ": " + message;
        }
    }

    //实例化在自己前进入展馆中的角色
    public static updateIDBefore: any = {
        Node: 9,
        WriteValue: (buf: ByteBuffer) => {
            buf.WriteInt(VeryCharacter._myCharacterIndex);
            let name: string;
            if (VeryCharacter.profileArray[0]) {
                name = VeryCharacter.profileArray[0] + "," + VeryCharacter.profileArray[1];
            } else name = VeryNettyPara.UserName + "," + "m";
            buf.WriteString(name);
        },
        Accept: (buf) => {
            let index = buf.ReadInt();
            let str = buf.ReadString().split(",");
            let bb: boolean = false;
            VeryCharacter._scence.onBeforeRenderObservable.add(() => {
                if (VeryCharacter._allCharacters.GetValue(index) && VeryCharacter._allCharacters.GetValue(index)._button && !bb) {
                    bb = true;
                    VeryCharacter._allCharacters.GetValue(index)._button.textBlock.text = str[0];
                    if (str[1] === "f") {
                        let ballMaterial = (VeryCharacter._allCharacters.GetValue(index)._ballMesh.material) as BABYLON.StandardMaterial;
                        let path = "./model/1/2.jpg";
                        if (Game.style === "dangjianfeng" || Game.style === "xindangjianfeng" || Game.style === "xindangjianfeng2" || Game.style === "xindangjianfeng3") {
                            path = "./model/2/2.jpg";
                        }
                        VeryCharacter._allCharacters.GetValue(index)._button.background = "#FED35365";
                        ballMaterial.diffuseTexture = new BABYLON.Texture(path, VeryCharacter._scence);

                    }
                }
            })


        }
    }

    public static updateIDAfter: any = {
        Node: 12,
        WriteValue: (buf: ByteBuffer, index: number, str: string) => {
            buf.WriteInt(index);
            buf.WriteString(str);
        },
        Accept: (buf) => {
            let index = buf.ReadInt();
            let str = buf.ReadString().split(",");
            let bb: boolean = false;
            VeryCharacter._scence.onBeforeRenderObservable.add(() => {
                if (VeryCharacter._allCharacters.GetValue(index) && VeryCharacter._allCharacters.GetValue(index)._button && !bb) {
                    bb = true;
                    VeryCharacter._allCharacters.GetValue(index)._button.textBlock.text = str[0];
                    if (str[1] === "f") {
                        let ballMaterial = (VeryCharacter._allCharacters.GetValue(index)._ballMesh.material) as BABYLON.StandardMaterial;
                        let path = "./model/1/2.jpg";
                        if (Game.style === "dangjianfeng" || Game.style === "xindangjianfeng" || Game.style === "xindangjianfeng2" || Game.style === "xindangjianfeng3") {
                            path = "./model/2/2.jpg";
                        }
                        VeryCharacter._allCharacters.GetValue(index)._button.background = "#FED35365";
                        ballMaterial.diffuseTexture = new BABYLON.Texture(path, VeryCharacter._scence);
                    }
                }
            })
        }
    }

}